import {Component, OnInit, ViewChild} from '@angular/core';
import {ReservationService, Reservations} from '../../reservation.service';
import {ClientService} from '../../client.service';
import {ReservationDetail} from '../../../../../projects/shared-lib/src/lib/models/reservation-detail';
import { HttpParams } from '@angular/common/http';
import {AnalyticsService} from '../../../shared/services/analytics.service';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {lastValueFrom} from 'rxjs';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import * as moment from "moment";
import { MatFormField, MatLabel, MatHint, MatSuffix } from '@angular/material/form-field';
import { MatDateRangeInput, MatStartDate, MatEndDate, MatDatepickerToggle, MatDateRangePicker } from '@angular/material/datepicker';
import { ClientReservationHeaderComponent } from '../client-reservation-header/client-reservation-header.component';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { JsonPipe } from '@angular/common';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent, ConfirmDialogData } from '../../../../../projects/shared-lib/src/lib/component/message/message.module';

@Component({
    selector: 'tw-reservations',
    templateUrl: './reservations.component.html',
    styleUrls: ['./reservations.component.css'],
    animations: [
        trigger('detailExpand', [
            state('collapsed,void', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    imports: [
        MatTable,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatFormField,
        MatLabel,
        MatDateRangeInput,
        FormsModule,
        ReactiveFormsModule,
        MatStartDate,
        MatEndDate,
        MatHint,
        MatDatepickerToggle,
        MatSuffix,
        MatDateRangePicker,
        MatCellDef,
        MatCell,
        ClientReservationHeaderComponent,
        MatIconButton,
        MatButton,
        MatIcon,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        MatPaginator,
        JsonPipe,
        TranslatePipe
    ]
})
export class ReservationsComponent implements OnInit {
    reservations: Reservations;
    dataSource: MatTableDataSource<ReservationDetail, any>;
    columnsToDisplay = ['detail'];
    expandedElement: any | null;
    columnsToDisplayWithExpand = [...this.columnsToDisplay, 'expand'];
    resultsLength: any;
    columnSelect: string;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    campaignOne = new FormGroup({
        start: new FormControl(),
        end: new FormControl(),
    });
    constructor(private reservationService: ReservationService,
                private clientService: ClientService,
                private analyticsService: AnalyticsService,
                public translate: TranslateService,
                private router: Router,
                private dialog: MatDialog) {
    }

    async ngOnInit() {
        const client = this.clientService.getClientLocal();
        this.analyticsService.trackInvoicesView();
        let extraParams = new HttpParams().set('limit','150');
        const reservations = await lastValueFrom(this.reservationService.getReservations(client.id, extraParams));
        reservations.reservations.sort((a, b) => {
            const dateA = new Date(a.eventStart);
            const dateB = new Date(b.eventStart);
            return dateA > dateB ? -1 : dateA < dateB ? 1 : 0;
        });

        this.reservations = reservations;
        this.dataSource = new MatTableDataSource(reservations.reservations);
        this.paginator._intl.itemsPerPageLabel = this.translate.currentLang === 'fr' ? 'Réservations par pages:':'Reservations per pages:';
        this.paginator._intl.nextPageLabel = this.translate.currentLang === 'fr' ? 'Page suivante':'Next page';
        this.paginator._intl.previousPageLabel = this.translate.currentLang === 'fr' ? 'Page précédente':'Previous page';
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.resultsLength = reservations.metadata?.totalElements || reservations.reservations.length;
        this.campaignOne.controls.end.valueChanges.subscribe(value => {
            const newValue = this.reservations.reservations.filter(value1 => {
                const dateA = new Date(value1.eventStart);
                const start = <moment.Moment>this.campaignOne.controls.start.value;
                const end = <moment.Moment>this.campaignOne.controls.end.value;
                if(!start || !end ){
                    return;
                }
                return start.toDate().getTime() <= dateA.getTime() && end.toDate().getTime() >= dateA.getTime();
            });
            this.dataSource.data = newValue;
        });
    }

    detailCell(name: string, element: ReservationDetail) {
        this.columnSelect = name;
        this.expandedElement = this.expandedElement === element ? null : element;
    }

    getDateFormatString():string {
        if (this.translate.currentLang === 'fr') {
            return 'DD/MM/YYYY – DD/MM/YYYY';
        }
        return 'MM/DD/YYYY – MM/DD/YYY'
    }

    async purchaseReservation(reservation: ReservationDetail) {
        try {
            await this.router.navigate(
                [this.translate.currentLang + '/checkout/mode'],
                { queryParams: { reservationToken: reservation.token } }
            );
        } catch (error) {
            console.error('Error purchasing reservation:', error);
        }
    }

    releaseReservation(reservation: ReservationDetail) {
        const dialogData: ConfirmDialogData = {
            message: this.translate.instant('reservation.confirmRelease'),
            confirmText: this.translate.instant('reservation.release'),
            cancelText: this.translate.instant('common.cancel')
        };

        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: dialogData,
            width: '400px'
        });

        dialogRef.afterClosed().subscribe(async (confirmed) => {
            if (!confirmed) {
                return;
            }

            try {
                const client = this.clientService.getClientLocal();
                await lastValueFrom(this.reservationService.releaseReservation(client.id, reservation.token));
                this.dataSource.data = this.dataSource.data.filter(r => r.token !== reservation.token);
                this.resultsLength = this.dataSource.data.length;
            } catch (error) {
                console.error('Error releasing reservation:', error);
                alert(this.translate.instant('reservation.releaseError'));
            }
        });
    }
}
